/**
 * Общие стили карточек секции «Сервисы и сброс кэша».
 * Раскладка - по ширине секции, а не окна: рядом с боковым меню профиля секция заметно уже окна.
 * Контейнер задает список карточек в ServicesCacheSection.
 */
export const SERVICES_WIDE = '@container (min-width: 560px)';

export const serviceCardSx = {
  p: 2.5,
  borderRadius: '16px',
  bgcolor: '#f8fafc',
  border: '1px solid #e2e8f0'
} as const;

/** Описание слева, кнопка справа; в узкой секции кнопка уходит под описание */
export const serviceRowSx = {
  ...serviceCardSx,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  gap: 2,
  [SERVICES_WIDE]: { flexDirection: 'row', alignItems: 'center' }
} as const;

/** В узкой секции кнопка тянется на всю ширину, в широкой - по тексту */
export const serviceButtonGrowSx = { flexGrow: 1, [SERVICES_WIDE]: { flexGrow: 0 } } as const;
export const serviceButtonFullSx = { width: '100%', [SERVICES_WIDE]: { width: 'auto' } } as const;
